import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        <div>
            {/* Navigation */}
            <nav class="bg-white shadow-lg">
                <div class="max-w-7xl mx-auto px-4">
                    <div class="flex justify-between items-center h-16">
                        <div class="flex items-center">
                            <span class="text-2xl font-bold text-blue-600">PredictFlow</span>
                        </div>
                        <div class="hidden md:flex items-center space-x-8">
                            <a href="#features" class="text-gray-700 hover:text-blue-600">Features</a>
                            <a href="#how-it-works" class="text-gray-700 hover:text-blue-600">How It Works</a>
                            <Link to="/pricing" class="text-gray-700 hover:text-blue-600">Pricing</Link>
                            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                                <Link to="/contact" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                                    Start Free Trial
                                </Link>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <div class="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                <div class="max-w-7xl mx-auto px-4 py-20">
                    <div class="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h1 class="text-4xl md:text-5xl font-bold mb-6">
                                Transform Big Data into Predictive Intelligence
                            </h1>
                            <p class="text-xl mb-8">
                                Build, train, and deploy machine learning models without writing code. Handle massive datasets with ease using our enterprise-grade platform.
                            </p>
                            <div class="space-x-4">
                                <button class="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100">
                                    <Link to="/contact" className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100">
                                        Contact Us
                                    </Link>
                                </button>
                                {/* <button class="border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600">
                                    Watch Demo
                                </button> */}
                            </div>
                        </div>
                        { /* <div class="hidden md:block">
                            <img src="/api/placeholder/600/400" alt="Platform Dashboard" class="rounded-lg shadow-xl"/>
                        </div> */ }
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div id="features" class="py-20 bg-white">
                <div class="max-w-7xl mx-auto px-4">
                    <h2 class="text-3xl font-bold text-center mb-12">Powerful Features for Enterprise ML</h2>
                    <div class="grid md:grid-cols-3 gap-8">
                        <div class="p-6 border rounded-lg">
                            <div class="text-blue-600 text-3xl mb-4">
                                <i class="fas fa-database"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-3">Data Processing Pipeline</h3>
                            <p class="text-gray-600">
                                Automated data cleaning, normalization, and feature selection tools to prepare your datasets for optimal model performance.
                            </p>
                        </div>
                        <div class="p-6 border rounded-lg">
                            <div class="text-blue-600 text-3xl mb-4">
                                <i class="fas fa-robot"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-3">AutoML Capabilities</h3>
                            <p class="text-gray-600">
                                Let our platform automatically select and tune the best algorithms for your specific use case.
                            </p>
                        </div>
                        <div class="p-6 border rounded-lg">
                            <div class="text-blue-600 text-3xl mb-4">
                                <i class="fas fa-chart-line"></i>
                            </div>
                            <h3 class="text-xl font-semibold mb-3">Advanced Visualization</h3>
                            <p class="text-gray-600">
                                Interactive dashboards showing model performance, feature importance, and prediction insights.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            { /* How it Works */}
            <div id="how-it-works" class="py-20 bg-gray-50">
                <div class="max-w-7xl mx-auto px-4">
                    <h2 class="text-3xl font-bold text-center mb-12">How It Works</h2>
                    <div class="grid md:grid-cols-4 gap-8">
                        <div class="text-center">
                            <div class="bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">1</div>
                            <h3 class="font-semibold mb-2">Upload Data</h3>
                            <p class="text-gray-600">Connect your data sources or upload files directly</p>
                        </div>
                        <div class="text-center">
                            <div class="bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">2</div>
                            <h3 class="font-semibold mb-2">Prepare</h3>
                            <p class="text-gray-600">Clean and transform your data automatically</p>
                        </div>
                        <div class="text-center">
                            <div class="bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">3</div>
                            <h3 class="font-semibold mb-2">Train</h3>
                            <p class="text-gray-600">Build and validate your predictive models</p>
                        </div>
                        <div class="text-center">
                            <div class="bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">4</div>
                            <h3 class="font-semibold mb-2">Deploy</h3>
                            <p class="text-gray-600">Deploy models via API or export predictions</p>
                        </div>
                    </div>
                </div>
            </div>

            { /* Call to Action */ }
            <div class="bg-blue-600 text-white py-16">
                <div class="max-w-4xl mx-auto text-center px-4">
                    <h2 class="text-3xl font-bold mb-6">Ready to Transform Your Data?</h2>
                    <p class="text-xl mb-8">Start your free trial today and see the power of enterprise-grade machine learning.</p>
                    <button class="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100">
                        <Link to="/contact" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100">
                            Start Free Trial
                        </Link>
                    </button>
                    
                </div>
            </div>

            {/*Footer*/}
            <footer class="bg-gray-800 text-gray-300 py-12">
                <div class="max-w-7xl mx-auto px-4">
                    <div class="grid md:grid-cols-4 gap-8">
                        <div>
                            <h3 class="text-white text-lg font-semibold mb-4">Byte Bridge Services</h3>
                            <p class="text-sm">Enterprise-grade machine learning platform for predictive analytics</p>
                        </div>
                        <div>
                            {/*<h4 class="text-white font-semibold mb-4">Product</h4>
                            <ul class="space-y-2 text-sm">
                                <li><a href="#" class="hover:text-white">Features</a></li>
                                <li><a href="#" class="hover:text-white">Pricing</a></li>
                                 <li><a href="#" class="hover:text-white">Documentation</a></li> 
                            </ul>*/}
                        </div>
                        <div>
                            {/* <h4 class="text-white font-semibold mb-4">Company</h4>
                            <ul class="space-y-2 text-sm">
                                <li><a href="#" class="hover:text-white">About</a></li>
                                <li><a href="#" class="hover:text-white">Blog</a></li>
                                <li><a href="#" class="hover:text-white">Careers</a></li>
                            </ul> */}
                        </div>
                        <div>
                            {/* <h4 class="text-white font-semibold mb-4">Connect</h4>
                            <ul class="space-y-2 text-sm">
                                <li><a href="#" class="hover:text-white">Contact</a></li>
                                <li><a href="#" class="hover:text-white">Twitter</a></li>
                                <li><a href="#" class="hover:text-white">LinkedIn</a></li>
                            </ul> */}
                        </div>
                    </div>
                    <div class="border-t border-gray-700 mt-8 pt-8 text-sm text-center">
                        © 2024 Byte Bridge Services. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default HomePage;